// extracted by mini-css-extract-plugin
module.exports = {"Indented":"NavigationEventRow_Indented__CqIHZ","Text":"NavigationEventRow_Text__k_BZE","Name":"NavigationEventRow_Name__d4aWl"};